// extracted by mini-css-extract-plugin
module.exports = {"headerCon":"_17xC0","topText":"_3aS5j","topTextY":"_14QVE","topTextX":"_3O0_l","storeSelect":"GcZ5i","storeDropdown":"_1Mdhe","updateStore":"_25m5R","menu":"HBEMX"};